<template>
   <div id="sign-up-container">
      <SignUp force-redirect-url="/onboarding/create-org" />
   </div>
</template>

<script lang="ts" setup>
import { SignUp } from "@clerk/vue"
import { useHead } from "@unhead/vue"
import { onMounted } from "vue"
import { useRoute } from "vue-router"
import { useOnboardingStore } from "@/stores/onboardingStore"

const route = useRoute()
const onboardingStore = useOnboardingStore()

onMounted(async () => {
   const tier = route.query.tier as string | undefined
   if (tier === "starter_tier" || tier === "professional_tier") {
      onboardingStore.setTier(tier)
   } else {
      onboardingStore.setTier(null)
   }
})

useHead({
   title: "Sign Up - ezbot.ai",
   meta: [
      {
         name: "description",
         content: "Sign up for ezbot.ai with a free trial",
      },
      {
         property: "og:title",
         content: "Sign Up - ezbot.ai",
      },
      {
         property: "og:description",
         content: "Sign up for ezbot.ai with a free trial",
      },
      {
         property: "og:url",
         content: "https://app.ezbot.ai/sign-up",
      },
      {
         property: "twitter:title",
         content: "Sign Up - ezbot.ai",
      },
      {
         property: "twitter:description",
         content: "Sign up for ezbot.ai with a free trial",
      },
      {
         property: "twitter:url",
         content: "https://app.ezbot.ai/sign-up",
      },
   ],
   link: [
      {
         rel: "canonical",
         href: "https://app.ezbot.ai/sign-up",
      },
   ],
})
</script>

<style lang="scss" scoped>
#sign-up-container {
   display: flex;
   flex-direction: column;
   justify-content: center;
   gap: 20px;
   align-items: center;
   min-height: 100vh;
   padding: 1.5em;
   background-image: linear-gradient(to top right, #007bff, #00aaff);
}

#mobile-install-card {
   width: 100%;
   max-width: 400px;
   background-color: white;
   border-radius: 10px;
   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
   ol {
      margin-top: 0.5em;
      padding-inline-start: 15px;
   }
}

#mobile-install-card-header-container {
   background-color: #41c055;
}
#mobile-install-card-header-text {
   color: white;
   font-weight: bold;
   font-size: 1.5rem;
   letter-spacing: -1px;
}
#remind-me-later-container {
   display: flex;
   gap: 20px;
   justify-content: center;
   margin-top: 1em;
}
#next-card-reference-mobile {
   display: inline;
}
#next-card-reference-desktop {
   display: none;
}
#you-need {
   margin-bottom: 0;
}
#to-get-started {
   margin-top: 1em;
}
@media (min-width: 768px) {
   #sign-up-container {
      flex-direction: row;
      height: 100vh;
   }
   #mobile-install-card-header-text {
      padding: 0 2em;
      font-size: 1.75rem;
      letter-spacing: 0px;
   }
   #next-card-reference-mobile {
      display: none;
   }
   #next-card-reference-desktop {
      display: inline;
   }
}
@media (min-width: 1024px) {
   #mobile-install-card {
      max-width: 600px;
   }
   #mobile-install-card-main-text {
      padding: 2em;
   }
   #remind-me-later-container {
      display: flex;
      gap: 20px;
      justify-content: start;
      margin-top: 1em;
   }
}
</style>
